(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('parameters.ville', {
                parent: 'parameters',
                url: '/villes',
                title: 'Villes',
                sidebarMeta: {
                    icon: 'glyphicon glyphicon-tower',
                    order: 8
                },
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_RESPONSABLE'],
                    pageTitle: 'josdaviApp.ville.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/ville/villes.html',
                        controller: 'VilleController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('ville');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
        }

})();
